import React, { lazy, Suspense } from "react";
import EstateHome from "@/pages/sites/EstateHome";
import { isEstate, isPreviewing } from "@/lib/sitePreview";
import { useBrand } from "@/lib/brand";
import { SITE_FALLBACK } from "@/lib/classicChunk";

// The classic design, fetched only if this agency is on it. See
// pages/classic/AgencySiteClassic.jsx for why it is not imported directly.
const AgencySiteClassic = lazy(() => import("@/pages/classic/AgencySiteClassic"));

function ClassicSite() {
  return <Suspense fallback={SITE_FALLBACK}><AgencySiteClassic /></Suspense>;
}


/**
 * AgencySite — a full, ready-to-launch website that any Foundation
 * tenant gets automatically at /t/:slug.
 *
 * Every section reads from the tenant's brand config, so editing
 * `/admin/brand` updates the live site with zero code changes. Featured
 * listings pull straight from `/api/crm/public/properties?tenant=<slug>`
 * so the site stays fresh as the agency adds instructions.
 *
 * This is Foundation Sites Phase 1 — one beautiful, opinionated,
 * conversion-focused template. Future phases will add multiple templates
 * and per-tenant custom sections.
 */
export default function AgencySite() {
  const brand = useBrand();
  // The new design, behind a flag nobody sees who has not typed it.
  //
  // `?theme=estate` on any page of an agency's site renders the design
  // pack's templates and `?theme=off` goes back; the choice is kept per TAB
  // so browsing the preview stays in it. Rebuilding a live agency's website
  // in place, with no way to look at it first, is not something to do to a
  // real business. See lib/sitePreview.js.
  const estate = isEstate(brand);
  const previewing = isPreviewing(brand);
  if (estate) return <EstateHome preview={previewing} />;
  return <ClassicSite />;
}
